"use client";

import EngineDateTable from "@/components/vrat/EngineDateTable";
import type { CalendarAmavasyaItem } from "@/lib/api/calendar";

export interface AmavasyaYearData {
  year: number;
  amavasyas: CalendarAmavasyaItem[];
}

export default function AmavasyaDates({ years }: { years: AmavasyaYearData[] }) {
  return (
    <EngineDateTable
      years={years.map(({ year, amavasyas }) => ({ year, entries: amavasyas }))}
      tabLabel="Amavasya"
      itemHeader="Amavasya"
      detailHeader="Hindu month"
      emptyMessage="Amavasya dates are computed live from the Vedic engine. The schedule could not be loaded right now — please refresh in a moment to see every new-moon date with its lunar month."
      footer="All Amavasya dates are computed from real planetary positions using the Swiss Ephemeris engine with Lahiri Ayanamsa — the tithi boundary, not a fixed calendar."
    />
  );
}
